import { Typography, Divider, Descriptions } from 'antd'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { formatDOB } from '../../lib/datetime'
import { reportEditPath } from '../../lib/reports'
import {
  DESCRIPTIONS_TWO_COLUMNS,
  MOBILE_MEDIA_QUERY,
} from '../../lib/responsive'

const useStyles = createUseStyles({
  container: {
    [MOBILE_MEDIA_QUERY]: {
      paddingBottom: 80,
    },
  },
  actionsFooter: {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 24,
    [MOBILE_MEDIA_QUERY]: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      padding: 12,
      backgroundColor: '#fff',
      borderTop: 'solid 1px #f0f0f0',
      gap: 8,
      zIndex: 100,
      flexDirection: 'column-reverse',
      marginTop: 0,
      '& > a': {
        flex: 1,
      },
    },
  },
})

export default function AssignedReportDetails({ report }) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Typography.Title level={4}>
        You have the following report assigned for review
      </Typography.Title>

      <Divider orientation="left">Report Information</Divider>
      <Descriptions column={DESCRIPTIONS_TWO_COLUMNS} size="small">
        <Descriptions.Item label="Title">{report.title}</Descriptions.Item>
        <Descriptions.Item label="Report Date">
          {formatDOB(report.reportDate)}
        </Descriptions.Item>
        <Descriptions.Item label="Last Update">
          {formatDOB(report.updatedAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Priority Report">
          {report.priority ? 'Yes' : 'No'}
        </Descriptions.Item>
      </Descriptions>
      <Divider orientation="left">Patient Information</Divider>
      <Descriptions column={DESCRIPTIONS_TWO_COLUMNS} size="small">
        <Descriptions.Item label="Anticoagulated Disease">
          {report.patient.anticoagulatedDisease ? 'Yes' : 'No'}
        </Descriptions.Item>
        <Descriptions.Item label="Atrial Fibrillation Disease">
          {report.patient.atrialFibrilationFlutterDisease ? 'Yes' : 'No'}
        </Descriptions.Item>
      </Descriptions>
      <Divider orientation="left">Device Information</Divider>
      <Descriptions column={DESCRIPTIONS_TWO_COLUMNS} size="small">
        <Descriptions.Item label="Model">
          {report.device.typeName}
        </Descriptions.Item>
        <Descriptions.Item label="Manufacturer">
          {report.device.manufacturer}
        </Descriptions.Item>
        <Descriptions.Item label="CPT Code">{report.cptCode}</Descriptions.Item>
        <Descriptions.Item label="Serial Number">
          {report.device.serialNumber}
        </Descriptions.Item>
      </Descriptions>
      <div className={classes.actionsFooter}>
        <a className="ant-btn ant-btn-primary" href={reportEditPath(report)}>
          Review Now
        </a>
      </div>
    </div>
  )
}

AssignedReportDetails.propTypes = {
  report: PropTypes.shape().isRequired,
}
